/**
 * @desc 分页
 */
const URL = "/rantion-rms";
import http, { updateResponse } from "@/http";
export type Response = defs.rms.ResponseDto<
  defs.rms.IPage<defs.rms.ExpenseReimbursementResponseDto>
>;
export function request(
  params: API.rms.expenseReimbursement.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/expenseReimbursement/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
